import { defineStore } from 'pinia';
import { ref } from 'vue';
import organizationsAPI from '@/api/organizations';
import type { Organization } from '@/types/Organization';

export const useOrganizationsStore = defineStore('organizations', () => {
  const organizations = ref<Organization[]>([]);
  
  const fetchOrganizations = async (params: any): Promise<{ data: Organization[]; }> => {
    try {
      const response = await organizationsAPI.getOrganizations(params);
      const data: Organization[] = response.data;
      organizations.value = data;
      return { data };
    } catch (error) {
      console.error('Error fetching organization s:', error);
      throw error;
    }
  };

  const fetchOrganizationById = async (id: number) => {
    try {
      const response = await organizationsAPI.getOrganizationById(id);
      return response.data.data as Organization;
    } catch (error) {
      console.error(`Error fetching organization  with ID ${id}:`, error);
    }
  };

  const createOrganization = async (organizationData: Partial<Organization>) => {
    try {
      const response = await organizationsAPI.createOrganization(organizationData);
      organizations.value.push(response.data.data as Organization);
      return response.data;
    } catch (error) {
      console.error('Error creating organization :', error);
    }
  };

  const updateOrganization = async (id: number, organizationData: Partial<Organization>) => {
    try {
      const response = await organizationsAPI.updateOrganization(id, organizationData);
      const updated = response.data.data as Organization;
      const index = organizations.value.findIndex((c) => c.id === id);
      if (index !== -1) {
        organizations.value[index] = updated;
      }
      return response.data;
    } catch (error) {
      console.error(`Error updating organization  with ID ${id}:`, error);
    }
  };

  const deleteOrganization = async (id: number) => {
    try {
      await organizationsAPI.deleteOrganization(id);
      organizations.value = organizations.value.filter((c) => c.id !== id);
    } catch (error) {
      console.error(`Error deleting organization  with ID ${id}:`, error);
    }
  };

  const fetchSuggestedPrice = async (params: string) => {
    try {
      const res = await organizationsAPI.getSuggestedPrice(params);
      return res.data.data?.[0]?.amount || 0;
    } catch (error) {
      console.error('Error fetching suggested price:', error);
      return 0;
    }
  };
  

  return {
    organizations,
    fetchOrganizations,
    fetchOrganizationById,
    createOrganization,
    updateOrganization,
    deleteOrganization,
    fetchSuggestedPrice
  };
});
